
export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const validatePhone = (phone: string): boolean => {
  const phoneRegex = /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
  return phoneRegex.test(phone);
};

export const validateName = (name: string): boolean => {
  const nameRegex = /^[a-zA-ZÀ-ÿ\s'-]{1,50}$/;
  return nameRegex.test(name);
};

export const validateAddress = (address: string): boolean => {
  const addressRegex = /^[a-zA-Z0-9À-ÿ\s\-\.,#]{1,100}$/;
  return addressRegex.test(address);
};

export const validateCity = (city: string): boolean => {
  const cityRegex = /^[a-zA-ZÀ-ÿ\s\-]{1,50}$/;
  return cityRegex.test(city);
};

export const validatePostalCode = (postalCode: string): boolean => {
  const postalCodeRegex = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
  return postalCodeRegex.test(postalCode);
};

export const validateCompany = (company: string): boolean => {
  const companyRegex = /^[a-zA-Z0-9À-ÿ\s\-\.]{0,100}$/;
  return company === "" || companyRegex.test(company);
};

export const passwordRequirements = [
  {
    label: "Au moins 8 caractères",
    regex: /.{8,}/,
  },
  {
    label: "Au moins une lettre majuscule",
    regex: /[A-Z]/,
  },
  {
    label: "Au moins une lettre minuscule",
    regex: /[a-z]/,
  },
  {
    label: "Au moins un chiffre",
    regex: /\d/,
  },
  {
    label: "Au moins un caractère spécial",
    regex: /[!@#$%^&*(),.?":{}|<>]/,
  },
];
